import { render, staticRenderFns } from "./TwVideo.vue?vue&type=template&id=b40163ea&scoped=true"
import script from "./TwVideo.vue?vue&type=script&lang=js"
export * from "./TwVideo.vue?vue&type=script&lang=js"
import style0 from "./TwVideo.vue?vue&type=style&index=0&id=b40163ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3_jycg54st5iyjtzg36i6kaokove/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40163ea",
  null
  
)

export default component.exports